import defaultCover from "../../styles/assets/background/sedan_hero.webp";

import defaultLogo from "../../../assets/logo.png";

const asUrl = (asset: string | {src?: string}): string => (typeof asset === "string" ? asset : asset.src || "");

/** Cover: seller upload → brand hero (never a single offer photo). */
export const resolveSellerCoverUrl = (coverUrl?: string | null): string => {
    if (coverUrl && coverUrl.trim()) {
        return coverUrl.trim();
    }
    return asUrl(defaultCover);
};

/** Logo: seller upload → zakupauto mark. */
export const resolveSellerLogoUrl = (logoUrl?: string | null): string => {
    if (logoUrl && logoUrl.trim()) {
        return logoUrl.trim();
    }
    return asUrl(defaultLogo);
};

export const isDefaultSellerLogo = (logoUrl?: string | null): boolean => !logoUrl || !logoUrl.trim();
export const isDefaultSellerCover = (coverUrl?: string | null): boolean => !(coverUrl && coverUrl.trim());
